<template>
        <el-form :model="grouponConfig" :rules="rules" label-width="120px">
            <el-form-item label="平台" prop="platformId">
                <el-select v-model="grouponConfig.platformId" clearable filterable placeholder="平台" :disabled="platformDisabled">
                    <el-option v-for="item in platformData"
                               :key="item.platformId"
                               :label="item.platformName"
                               :value="item.platformId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="团购商品类型" prop="grouponType">
                <el-select v-model="grouponConfig.grouponType" clearable filterable placeholder="团购商品类型">
                    <el-option v-for="item in grouponTypeList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="成团人数" prop="joinNum">
                <el-input-number v-model="grouponConfig.joinNum" :min="2" :max="10" :step="1"
                                 placeholder="0 "></el-input-number>
            </el-form-item>
            <el-form-item label="团购超时时间" prop="grouponHour">
                <el-input-number v-model="grouponConfig.grouponHour" :min="1" :max="48" :step="1"
                                 placeholder="0 "></el-input-number>(单位:小时)
            </el-form-item>
            <el-form-item label="拼团列表" prop="name">
                <el-select v-model="grouponConfig.isShow" placeholder="拼团列表" >
                    <el-option v-for="item in groupListIsShow"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否置顶" prop="isMain">
                <el-select v-model="grouponConfig.isMain" placeholder="是否置顶">
                    <el-option v-for="item in mainGroup"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="参团用户类型" prop="allowUserType">
                <el-select v-model="grouponConfig.allowUserType" clearable filterable placeholder="允许参团用户类型">
                    <el-option v-for="item in allowUserTypeList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-button @click="showDialog = false">取 消</el-button>
                <el-button type="primary" @click="saveGrouponConfig()" class="header-btn">
                    保 存
                </el-button>
            </el-form-item>
        </el-form>
</template>

<script>
    import {getGrouponConfigApi, saveGrouponConfigApi} from "../../api/api";

    export default {
        name: "groupPurchaseConfig",
        data(){
            return{
                grouponConfig: {
                    id: '',
                    activeNo: this.$route.query.activeNo,
                    joinNum: 3,
                    /*团购类型 1，实物订单，2 优惠券*/
                    grouponType: 1,
                    /*平台标示*/
                    platformId: 1,
                    grouponHour: 2,
                    /*是否显示拼团列表*/
                    isShow: 1,
                    /*是否是主拼团 1,是; 0 否*/
                    isMain: 1,
                    allowNum: 0,
                    createTime:'',
                    platformGroupId:'',
                    /*允许参团的用户类型  1：新用户  2：所有用户*/
                    allowUserType: 1
                },
                grouponTypeList: [{id: 1, name: '实物'}, {id: 2, name: '优惠券'}],
            }
        },
        mounted(){
            this.getGrouponConfig();
        },
        methods:{
            getGrouponConfig() {
                this.loading = true;
                getGrouponConfigApi({activeNo: this.grouponConfig.activeNo}).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.platformDisabled = true;
                        if (res.data.value.grouponConfig != null) {
                            this.grouponConfig = res.data.value.grouponConfig;
                        }else {
                            this.$message({
                                showClose: true,
                                message: '团购未配置，请继续配置',
                                type: 'success'
                            });
                        }
                        this.platformData = res.data.value.platFormList;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            saveGrouponConfig(){
                this.loading = true;
                saveGrouponConfigApi(this.grouponConfig).then((res) => {
                    this.loading = false;
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    this.showGrouponDialog=false;
                });
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/active/groupPurchaseConfig.vue